import { useCustomerTypeActions, CustomerType, useCustomerTypeLoaders} from "../../..";
import { ImportCustomerTypeField, useImportCustomerType } from "../../../../../features/importer"

export const useActions = () => {
    const importCustomerType = useImportCustomerType();
    const { saveCustomerType } = useCustomerTypeActions();
    const { findAllCustomerTypes } = useCustomerTypeLoaders()();

    const checkNameExists = async (name: string, currentId?: string) => {
        if (!name) return undefined;

        const all = await findAllCustomerTypes();
        
        return all.find(ct => 
            ct.name?.toLowerCase() === name.toLowerCase() && 
            ct.id !== currentId
        );
    };

    const persist = async (ct: CustomerType, id?: string) => {
        return saveCustomerType(id ? { ...ct, id } : ct);
    };

    const processImport = async (
        file: File, 
        priceFieldValue: ImportCustomerTypeField,
        existingId?: string,
        baseCustomerTypeId?: string
    ) => {
        return await importCustomerType(file, priceFieldValue, async (ct) => ct, baseCustomerTypeId, existingId);
    };

    return { processImport, checkNameExists, persist };
};
